module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-6-3d591e0e87e06762060eeee07776403d.jpg";